import {
  Color,
  List,
  Paragraph
} from '@eggplant/pattern-library'

const RunPerDayInfo = () =>
  <>
    <Paragraph>
      <Color variant='theme-description-text'>
        The Test Case Run Status Graph provides a visual representation of passed, failed, errored,
        and cancelled test case run statuses per day, based on selected filters.
        This graph offers valuable insights into the overall performance of
        your test cases within a specified timeframe
      </Color>
    </Paragraph>
    <br />
    <Paragraph>
      <Color variant='theme-description-text'>
        Key Features:
      </Color>
      <br />
    </Paragraph>
    <List variant='description'>
      <Paragraph>
        <Color variant='theme-description-text'>
          Graphical Representation: The data is presented in an intuitive graph format,
          making it easy to grasp the distribution of different test case run statuses over time.
        </Color>
      </Paragraph>
      <Paragraph>
        <Color variant='theme-description-text'>
          Filter Options: Customize the graph using filters such as date range and filtering by model or suite.
          This allows you to focus on specific subsets of your test cases for deeper analysis.
        </Color>
      </Paragraph>
      <Paragraph>
        <Color variant='theme-description-text'>
          Comprehensive View: Gain a comprehensive understanding of how your test cases perform each day,
          tracking changes and trends in their run statuses.
        </Color>
      </Paragraph>
    </List>
    <br />
    <Paragraph>
      <Color variant='theme-description-text'>
        The Test Case Run Status Graph empowers you to assess the effectiveness of your testing efforts,
        identify patterns, and make informed decisions based on the performance of your test cases.
      </Color>
    </Paragraph>
  </>

export default RunPerDayInfo
